import { createStore } from "@tredespace/ui/lib";

export type Theme = "dark" | "light";

export type ThemeState = Readonly<{ theme: Theme }>;

/**
 * Light is the app default, so `index.html` ships `data-theme="light"` on the
 * root and there is no dark flash before this store is read at boot. The
 * library's own default is dark, which is why light needs the attribute.
 */
export const themeState = createStore<ThemeState>({ theme: "light" });
